export default "__VITE_ASSET__tfASpSFb__"